import styled from 'styled-components';
import { SecondaryButton } from 'styles/elements/buttons';
import { ColumnDiv } from 'styles/elements/div';

export const SkipSearchButton = styled(SecondaryButton)`
  align-self: flex-start;
  margin-top: 20px;
  line-height: 35px;
  height: 70px;
`;

export const ResultsContainer = styled(ColumnDiv)`
  position: absolute;
  z-index: 1;
  display: ${({ isHidden }) => (isHidden ? 'none' : 'flex')};
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  color: #2A2C2E;
  padding: 8px 0;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  max-height: 220px;
  overflow-y: auto;
`;

export const SearchResultButton = styled.button`
  border: none;
  background: white;
  cursor: pointer;
  border-radius: 0;
  padding: 3px 20px;
  font-size: 30px;
  line-height: 40px;
  text-align: left;
  font-family: ${({ theme }) => theme.fontFamilyLight};
  :hover {
    color: white;
    background-color: #025aa5;
  }
`;

export const TypeaheadSearchContainer = styled(ColumnDiv)`
  position: relative;
`;
